import { Component, EventEmitter, input, Input, OnInit, Output } from '@angular/core';
import { LanguageService } from 'src/app/core/services/language.service';
import { LoaderService } from 'src/app/core/services/loader.service';
import { LocalService } from '../../../core/services/local.service';
import { ChildrenAnimation, fadeUpDown } from '../../animations/allAnimations';
import { ModuleName } from '../../enums/ModuleName';
import { LanguagePipe } from '../../pipes/language.pipe';
import { Entity } from '@ex/module/core/data-models/Entity';
import { EntityService } from '@ex/module/core/services/entity.service';
import { take } from 'rxjs/operators';
import { TenantService } from '@ex/module/core/services/tenant.service';
import { TranslatePipe } from '../../pipes/translate.pipe';
declare var $: any;

@Component({
  selector: 'q-header',
  templateUrl: './q-header.component.html',
  styleUrls: ['./q-header.component.scss'],
  animations: [ChildrenAnimation, fadeUpDown]
})
export class QHeaderComponent implements OnInit {
  imgPath: string = 'assets/img/svg/logo.svg';
  @Input('language') set lang(language: any) {
    if (language) {
      this.language = language
      this.localService.setJsonValue('language', this.language);
      this.isArabic(language);
    }
  };
  allQuestions = [];
  currentQuestion;
  currentSection;
  question;
  section;
  @Input() supportedLanguages;
  @Input() questionnaire;
  @Input() language;
  selectedCompany: Entity;
  @Input('selectedCompany') set com(company: Entity) {
    if (!company)
      return;
    this.selectedCompany = company;
    this.fetchCompany(this.selectedCompany);
  };
  @Input() title;
  @Input() subtitle;
  @Input() stage: string;
  @Input() flatted;
  @Input() module
  @Input('question') set que(q) {
    if (q)
      this.question = q;
    if (!this.flatted) {
      this.allQuestions = this.questionnaire.sections.flatMap(x => x.questions).filter(f => !f.skipped);
      this.section = this.questionnaire.sections.find(s => s.questions.find(qu => qu.key == q.key));
      this.currentSection = this.questionnaire.sections.indexOf(this.section);
    }
    else if (this.flatted)
      this.allQuestions = this.questionnaire?.questions;

    this.currentQuestion = this.allQuestions?.indexOf(q);

    this.loader.hideLoader();

  };
  @Output() languageChanged = new EventEmitter();
  showLangage: boolean = false;
  constructor(private localService: LocalService, private languageService: LanguageService, public loader: LoaderService, private languagePipe: LanguagePipe, private tenantService: TenantService, private translationPipe:TranslatePipe) { }

  ngOnInit(): void {
    if (!this.question)
      this.loader.displayLoader();
  }
  ModuleNames = ModuleName
  isArabic(language) {
    if (this.languagePipe.transform(language)) {
      $("body").removeClass('ltr')
      $("body").addClass('rtl').attr("dir", "rtl");
    }
    else {
      $("body").removeClass('rtl')
      $("body").addClass('ltr').attr("dir", "ltr")

    }
  }
  getLongLanguageName(langISO: string) {
    // console.log(langISO);

    if (langISO)
      return this.languageService.getLongLanguageName(langISO, langISO);
  }

  closeDropdown(menu) {
    if (this[menu]) this[menu] = false;
  }

  fetchCompany(company: Entity) {
    this.tenantService.fetchTenant(company?.tenantKey).pipe(take(1)).subscribe(x => {
      if (x?.clientLabel == "White-Labeled" && this.selectedCompany?.logoURL)
        this.imgPath = this.selectedCompany?.logoURL;
    })
  }

  resolveTranslation(key: string) {
    let translation = this.translationPipe.transform(key, this.language, this.module);

    if (translation == key || !translation)
      translation = this.translationPipe.transform(key, this.language, this.ModuleNames.Shared);

    return translation;
  }
}
